import React from "react";
import { Stage, Layer, Rect } from "react-konva";

const GridStage = ({ size = 32, color = "#cfcfcf" }) => {
  return (
    <Stage
      width={window.innerWidth}
      height={window.innerHeight}
      className="gridStage"
      opacity={0.3}
    >
      <Layer>
        <Grid
          width={window.innerWidth}
          height={window.innerHeight}
          gridSize={size}
          color={color}
        />
      </Layer>
    </Stage>
  );
};
export default GridStage;

const Grid = ({ width, height, gridSize, color }) => {
  const rows = Math.floor(width / gridSize);
  const gridLines = [];

  for (let i = 1; i < rows; i++) {
    gridLines.push(
      <Rect
        key={`row-${i}`}
        width={width}
        height={1}
        x={0}
        y={i * gridSize}
        fill={color}
      />
    );

    gridLines.push(
      <Rect
        key={`col-${i}`}
        width={1}
        height={height}
        x={i * gridSize}
        y={0}
        fill={color}
      />
    );
  }

  return gridLines;
};
